import React, { useState, useEffect } from 'react';
import { auth, db } from '../firebase/fire';
import { signOut } from 'firebase/auth';
import { collection, query, where, getDocs, doc, getDoc, FieldPath, documentId, updateDoc, Timestamp } from 'firebase/firestore';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment, { now } from 'moment';
import { useNavigate, useLocation } from "react-router-dom";
import { Tabs } from 'antd';
import Item from 'antd/es/list/Item';
import { useReminders } from './ReminderContext';
import { FaCheck } from 'react-icons/fa';


const localizer = momentLocalizer(moment);

const CoachDashboard = () => {
    const [coachData, setCoachData] = useState(null);
    const [events, setEvents] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [worklogReport, setWorklogReport] = useState([]);
    const [view, setView] = useState('agenda');
    const [totalScheduledTime, setTotalScheduledTime] = useState('');
    const [totalActualTime, setTotalActualTime] = useState('');
    const localizer = momentLocalizer(moment);
    const [activeTab, setActiveTab] = useState('classes');
    const [studentBookings, setStudentBookings] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();
    const user = location.state?.user;
    const [loading, setLoading] = useState(false);
    const { initializeAudio, audioInitialized } = useReminders();

    const [agreementDate, setAgreementDate] = useState(false);
    const [oldAgreement, setOldAgreement] = useState(null);
    const [newAgreement, setNewAgreement] = useState(null);
    const [hasAcceptedNewAgreement, setHasAcceptedNewAgreement] = useState(false);
    const [instructorId, setInstructorId] = useState(null);

    useEffect(() => {
        if (user) {
            setInstructorId(user);
        }
    }, [user]);


    useEffect(() => {
        if (instructorId) {
            fetchAgreements(instructorId);
        }
    }, [instructorId]);

    const fetchAgreements = async (instructorId) => {
        try {
            const userDocRef = doc(db, "coaches", instructorId);
            const userDoc = await getDoc(userDocRef);
            const userData = userDoc.data();
            setOldAgreement(userData?.signedAgreement);
            setAgreementDate(userData?.agreementDate);

            const newAgreementRef = doc(db, "agreements", "instructor");
            const newAgreementDoc = await getDoc(newAgreementRef);
            setNewAgreement(newAgreementDoc.data());

            setLoading(false);
           
        } catch (error) {
            console.error("Error fetching agreements:", error);
            setLoading(false);
        }
    };

    const handleDeclineNewAgreement = async () => {

    }
    const handleAcceptNewAgreement = async () => {
        try {
            setLoading(true);
            const userDocRef = doc(db, "coaches", instructorId);
           
            const fileData = newAgreement.fileData;

            await updateDoc(userDocRef, {
                signedAgreement: fileData,
                agreementDate: Timestamp.now(),
            });

            setHasAcceptedNewAgreement(true);
            setLoading(false);
            alert("Agreement updated succesfully");
            setActiveTab('1');
        } catch (error) {
            console.error("Error accepting new agreement:", error);
            setLoading(false);
        }
    };


    useEffect(() => {
        const fetchCoachData = async () => {
            const user = auth.currentUser;
            if (user) {
                const coachDoc = await getDoc(doc(db, 'coaches', user.uid));
                if (coachDoc.exists()) {
                    setCoachData(coachDoc.data());
                    fetchScheduledClasses(coachDoc.data().name);
                    fetchStudentBookings(coachDoc.data().name);
                }
            }
        };

        fetchCoachData();
    }, []);

    const fetchScheduledClasses = async (coachName) => {
        const classesQuery = query(
            collection(db, 'classSchedule'),
            where('coaches', 'array-contains', coachName)
        );
        const querySnapshot = await getDocs(classesQuery);
        const classEvents = [];

        const startDate = moment().startOf('year');
        const endDate = moment().add(1, 'year').endOf('year');

        querySnapshot.forEach((doc) => {
            const classData = doc.data();
            if (classData.isSpecialClass) {
                const specialClassDate = moment(classData.specialClassDate);
                if (specialClassDate.isBetween(startDate, endDate, null, '[]')) {
                    classEvents.push({
                        id: doc.id,
                        title: classData.className,
                        start: specialClassDate.set({
                            hour: parseInt(classData.startTime.split(':')[0]),
                            minute: parseInt(classData.startTime.split(':')[1]),
                        }).toDate(),
                        end: specialClassDate.set({
                            hour: parseInt(classData.endTime.split(':')[0]),
                            minute: parseInt(classData.endTime.split(':')[1]),
                        }).toDate(),
                        isSpecial: true,
                    });
                }
            } else {
                // Regular weekly classes
                const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
                classData.days.forEach((day) => {
                    const dayIndex = daysOfWeek.indexOf(day);
                    let currentDate = moment(startDate).day(dayIndex);

                    while (currentDate.isSameOrBefore(endDate)) {
                        classEvents.push({
                            id: doc.id,
                            title: classData.className,
                            start: currentDate.clone().set({
                                hour: parseInt(classData.startTime.split(':')[0]),
                                minute: parseInt(classData.startTime.split(':')[1]),
                            }).toDate(),
                            end: currentDate.clone().set({
                                hour: parseInt(classData.endTime.split(':')[0]),
                                minute: parseInt(classData.endTime.split(':')[1]),
                            }).toDate(),
                            isSpecial: false,
                        });
                        currentDate.add(1, 'week');
                    }
                });
            }
        });

        setEvents(classEvents);
    };

    const fetchStudentBookings = async (coachUid) => {
        try {
            const bookingQuery = collection(db, 'bookings');
            const bookingSnapshot = await getDocs(bookingQuery);
            let bookingsData = [];

            for (const docSnapshot of bookingSnapshot.docs) {
                const bookingData = docSnapshot.data();
                const classId = bookingData.classId;

                // Use the imported 'doc' function here
                const classScheduleRef = doc(db, 'classSchedule', classId);
                const classScheduleDoc = await getDoc(classScheduleRef);


                if (classScheduleDoc.exists()) {
                    const classScheduleData = classScheduleDoc.data();
                    if (classScheduleData.coaches && classScheduleData.coaches.includes(coachUid)) {
                        bookingsData.push({
                            id: docSnapshot.id,
                            ...bookingData,
                        });
                    }
                }
            }

            bookingsData = bookingsData.filter(booking => {
                let bookingDate = new Date(booking.date);
                let today = new Date();
                today.setHours(0, 0, 0, 0);
                return bookingDate >= today;
            });

            setStudentBookings(bookingsData);
        } catch (error) {
            console.error("Error fetching student bookings:", error);
        }
    };

    const handleGenerateReport = async () => {
        if (!auth.currentUser) {
            console.error("No user is currently logged in");
            return;
        }

        const startDateStr = moment(startDate).format('YYYY-MM-DD');
        const endDateStr = moment(endDate).format('YYYY-MM-DD');

        const worklogQuery = query(
            collection(db, 'worklog'),
            where('__name__', '>=', startDateStr),
            where('__name__', '<=', endDateStr)
        );

        try {
            const querySnapshot = await getDocs(worklogQuery);
            const report = [];
            let totalScheduledMinutes = 0;
            let totalActualMinutes = 0;

            // Fetch the current user's coach data
            const coachDoc = await getDoc(doc(db, "coaches", auth.currentUser.uid));
            if (!coachDoc.exists()) {
                console.error("Instructor document not found");
                return;
            }
            const coachData = coachDoc.data();

            querySnapshot.forEach((doc) => {
                const date = doc.id;
                const coachLogs = doc.data()[coachData.name];

                if (coachLogs) {
                    Object.entries(coachLogs).forEach(([classId, classData]) => {
                        // Check if classData is an array or an object
                        const classEntries = Array.isArray(classData) ? classData : [classData];

                        classEntries.forEach(entry => {
                            const scheduledStart = moment(`${date} ${entry.scheduledStart}`, 'YYYY-MM-DD HH:mm');
                            const scheduledEnd = moment(`${date} ${entry.scheduledEnd}`, 'YYYY-MM-DD HH:mm');

                            let actualLogin;
                            if (entry.loginTime && entry.loginTime.toDate instanceof Function) {
                                actualLogin = moment(entry.loginTime.toDate());
                            } else {
                                console.error(`Invalid loginTime for class ${classId} on ${date}`);
                                actualLogin = scheduledStart; // Use scheduled start as a fallback
                            }

                            const timeDiff = actualLogin.diff(scheduledStart, 'minutes');
                            const scheduledDuration = Math.ceil(scheduledEnd.diff(scheduledStart, 'minutes'));
                            let actualDuration;

                            if (timeDiff <= 0) {
                                actualDuration = scheduledDuration;
                            } else {
                                actualDuration = Math.max(0, scheduledEnd.diff(actualLogin, 'minutes'));
                            }

                            actualDuration = Math.ceil(actualDuration);
                            totalScheduledMinutes += scheduledDuration;
                            totalActualMinutes += actualDuration;

                            report.push({
                                date: date,
                                className: entry.className,
                                scheduledStartTime: scheduledStart.format('HH:mm'),
                                scheduledEndTime: scheduledEnd.format('HH:mm'),
                                actualLoginTime: actualLogin.format('HH:mm'),
                                timeDifference: formatTimeDifference(timeDiff),
                                scheduledDuration: formatDuration(scheduledDuration),
                                actualDuration: formatDuration(actualDuration)
                            });
                        });
                    });
                }
            });

            setWorklogReport(report);
            setTotalScheduledTime(formatDuration(totalScheduledMinutes));
            setTotalActualTime(formatDuration(totalActualMinutes));
        } catch (error) {
            console.error("Error generating report:", error);
        }
    };

    const formatTimeDifference = (minutes) => {
        if (minutes === 0) return 'On time';
        const abs = Math.abs(minutes);
        return `${minutes > 0 ? 'Late by' : 'Early by'} ${abs} minute${abs !== 1 ? 's' : ''}`;
    };

    const formatDuration = (minutes) => {
        const hours = Math.floor(minutes / 60);
        const mins = minutes % 60;
        if (hours === 0) return `${mins} min${mins !== 1 ? 's' : ''}`;
        if (mins === 0) return `${hours} hr${hours !== 1 ? 's' : ''}`;
        return `${hours} hr${hours !== 1 ? 's' : ''} ${mins} min${mins !== 1 ? 's' : ''}`;
    };

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            navigate("/member-login");
        } catch (error) {
            console.error("Error signing out: ", error);
        }
    };
    return (
        <div className="p-4 bg-gray-100 min-h-screen">
            <div className="max-w-7xl mx-auto">
                <header className="flex justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold text-gray-800">Instructor Dashboard</h1>
                    <button onClick={handleSignOut} className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded transition duration-300">Sign Out</button>
                </header>

                <div className="bg-white shadow-md rounded-lg overflow-hidden">
                    <div className="flex border-b">
                        <button
                            className={`flex-1 py-4 px-6 text-center font-medium ${activeTab === 'classes' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                            onClick={() => setActiveTab('classes')}>
                            Scheduled Classes
                        </button>
                        <button
                            className={`flex-1 py-4 px-6 text-center font-medium ${activeTab === 'worklog' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                            onClick={() => setActiveTab('worklog')}>
                            Log
                        </button>
                        <button
                            className={`flex-1 py-4 px-6 text-center font-medium ${activeTab === 'bookings' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                            onClick={() => setActiveTab('bookings')}>
                            Member Bookings
                        </button>
                        <button
                            className={`flex-1 py-4 px-6 text-center font-medium ${activeTab === 'agreement' ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
                            onClick={() => setActiveTab('agreement')}>
                            Agreement
                        </button>
                    </div>

                    <div className="p-6">
                        <div className="mb-4 flex items-center gap-4">
                            {!audioInitialized ? (
                                <button
                                    onClick={initializeAudio}
                                    className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 font-medium"
                                >
                                    🔊 Enable Audio Reminders
                                </button>
                            ) : (
                                <div className="px-4 py-2 bg-green-100 text-green-800 rounded-lg font-medium flex items-center gap-2">
                                    <FaCheck className="text-lg" /> Audio Reminders Enabled
                                </div>
                            )}
                        </div>

                        {activeTab === 'classes' && (
                            <div>
                                <h2 className="text-2xl font-semibold mb-4 text-gray-700">Your Scheduled Classes</h2>
                                <Calendar
                                    localizer={localizer}
                                    events={events}
                                    startAccessor="start"
                                    endAccessor="end"
                                    style={{ height: 500 }}
                                    views={['month', 'week', 'day', 'agenda']}
                                    view={view}
                                    onView={setView}
                                    eventPropGetter={(event) => ({
                                        className: event.isSpecial ? 'bg-yellow-200 border-yellow-400' : 'bg-blue-200 border-blue-400',
                                        style: {
                                            border: '1px solid',
                                            borderRadius: '4px',
                                            padding: '2px 5px',
                                        }
                                    })}
                                />
                            </div>
                        )}

                        {activeTab === 'worklog' && (
                            <div>
                                <h2 className="text-2xl font-semibold mb-4 text-gray-700"> Log Report</h2>
                                <div className="flex flex-wrap items-center mb-6 gap-4">
                                    <div>
                                        <label htmlFor="start-date" className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
                                        <DatePicker
                                            id="start-date"
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            selectsStart
                                            startDate={startDate}
                                            endDate={endDate}
                                            className="p-2 border rounded shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                    <div>
                                        <label htmlFor="end-date" className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
                                        <DatePicker
                                            id="end-date"
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)}
                                            selectsEnd
                                            startDate={startDate}
                                            endDate={endDate}
                                            minDate={startDate}
                                            className="p-2 border rounded shadow-sm focus:ring-blue-500 focus:border-blue-500"
                                        />
                                    </div>
                                    <div className="self-end">
                                        <button onClick={handleGenerateReport} className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded transition duration-300">Generate Report</button>
                                    </div>
                                </div>

                                {worklogReport.length > 0 && (
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full bg-white border border-gray-300">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="py-2 px-4 border-b text-left">Date</th>
                                                    <th className="py-2 px-4 border-b text-left">Class Name</th>
                                                    <th className="py-2 px-4 border-b text-left">Scheduled Start Time</th>
                                                    <th className="py-2 px-4 border-b text-left">Scheduled End Time</th>
                                                    <th className="py-2 px-4 border-b text-left">Scheduled Duration</th>
                                                    <th className="py-2 px-4 border-b text-left">Actual Login Time</th>
                                                    <th className="py-2 px-4 border-b text-left">Time Difference</th>
                                                    <th className="py-2 px-4 border-b text-left">Actual Duration</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {worklogReport.map((log, index) => (
                                                    <tr key={index} className={index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}>
                                                        <td className="py-2 px-4 border-b">{log.date}</td>
                                                        <td className="py-2 px-4 border-b">{log.className}</td>
                                                        <td className="py-2 px-4 border-b">{log.scheduledStartTime}</td>
                                                        <td className="py-2 px-4 border-b">{log.scheduledEndTime}</td>
                                                        <td className="py-2 px-4 border-b">{log.scheduledDuration}</td>
                                                        <td className="py-2 px-4 border-b">{log.actualLoginTime}</td>
                                                        <td className="py-2 px-4 border-b">{log.timeDifference}</td>
                                                        <td className="py-2 px-4 border-b">{log.actualDuration}</td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                            <tfoot>
                                                <tr className="bg-gray-100 font-bold">
                                                    <td colSpan="4" className="py-2 px-4 border-b text-right">Total:</td>
                                                    <td className="py-2 px-4 border-b">{totalScheduledTime}</td>

                                                    <td colSpan="2" className="py-2 px-4 border-b text-right">Total:</td>
                                                    <td className="py-2 px-4 border-b">{totalActualTime}</td>
                                                </tr>

                                            </tfoot>
                                        </table>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === 'bookings' && (
                            <div>
                                <h2 className="text-2xl font-semibold mb-4 text-gray-700">Member Bookings</h2>
                                {studentBookings.length > 0 ? (
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full leading-normal">
                                            <thead>
                                                <tr>
                                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                        Student Email
                                                    </th>
                                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                        Class Name
                                                    </th>
                                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                        Date
                                                    </th>
                                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                        Start Time
                                                    </th>
                                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                                        End Time
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {studentBookings.map((booking) => (
                                                    <tr key={booking.id}>
                                                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                            {booking.email}
                                                        </td>
                                                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                            {booking.className}
                                                        </td>
                                                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                            {booking.date}
                                                        </td>
                                                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                            {booking.startTime}
                                                        </td>
                                                        <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                                            {booking.endTime}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                ) : (
                                    <p>No student bookings found for your classes.</p>
                                )}
                            </div>
                        )}
                        {activeTab === 'agreement' && (
                            <div className="bg-white shadow-2xl rounded-lg p-4 sm:p-8 w-full max-w-4xl">
                                <Tabs defaultActiveKey="1">

                                    {newAgreement && (newAgreement.timestamp) > (agreementDate) || agreementDate == null ? (
                                        <>
                                            <Item tab="Old Agreement" key="1">
                                                {oldAgreement ? (
                                                    <div>
                                                        <div className="agreement-text">

                                                            {oldAgreement ? (
                                                                <div>
                                                                    <embed
                                                                        src={`${oldAgreement}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        type="application/pdf"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>{oldAgreement.text}</p>
                                                            )}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p>No agreement found.</p>
                                                )}
                                            </Item>

                                            <Item tab="New Agreement" key="2">
                                                {newAgreement ? (
                                                    <div>
                                                        <div className="agreement-text">
                                                            {newAgreement.fileData ? (
                                                                <div>
                                                                    <embed
                                                                        src={`${newAgreement.fileData}`}
                                                                        width="100%"
                                                                        height="600px"
                                                                        type="application/pdf"
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <p>{newAgreement.text}</p>
                                                            )}
                                                        </div>
                                                        <div className="mt-4 flex space-x-4">
                                                            <button
                                                                onClick={handleAcceptNewAgreement}
                                                                className="bg-green-500 text-white px-4 py-2 rounded"
                                                            >
                                                                Agree
                                                            </button>
                                                            <button
                                                                onClick={handleDeclineNewAgreement}
                                                                className="bg-red-500 text-white px-4 py-2 rounded"
                                                            >
                                                                Decline
                                                            </button>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <p>Loading new agreement...</p>
                                                )}
                                            </Item>
                                        </>
                                    ) : (
                                        <Item tab="Signed Agreement" key="1">
                                            {oldAgreement ? (
                                                <div>
                                                    <div className="agreement-text">
                                                        {oldAgreement ? (
                                                            <div>
                                                                <embed
                                                                    src={`${oldAgreement}`}
                                                                    width="100%"
                                                                    height="600px"
                                                                    type="application/pdf"
                                                                />
                                                            </div>
                                                        ) : (
                                                            <p>{oldAgreement.text}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            ) : (
                                                <p>No agreement found.</p>
                                            )}
                                        </Item>
                                    )}
                                </Tabs>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default CoachDashboard;